import React from 'react';
import PropTypes from 'prop-types';
import Bike from '#/shared/components/GeneratedIcons/trimet/Bike';
import Bus from '#/shared/components/GeneratedIcons/trimet/Bus';
import Car from '#/shared/components/GeneratedIcons/trimet/Car';
import Ferry from '#/shared/components/GeneratedIcons/trimet/Ferry';
import AerialTram from '#/shared/components/GeneratedIcons/trimet/AerialTram';
import Escooter from '#/shared/components/GeneratedIcons/trimet/Escooter';
import Wes from '#/shared/components/GeneratedIcons/trimet/Wes';
import Max from '#/shared/components/GeneratedIcons/trimet/Max';
import Walk from '#/shared/components/GeneratedIcons/trimet/Walk';
import Streetcar from '#/shared/components/GeneratedIcons/trimet/Streetcar';
import TriMet from '#/shared/components/GeneratedIcons/trimet/LogoIcon';
import {
  AERIAL_TRAM_MODE,
  BICYCLE_MODE,
  BICYCLE_RENT_MODE,
  BUS_FX_MODE,
  BUS_MODE,
  CAR_HAIL_MODE,
  CAR_MODE,
  CAR_RENT_MODE,
  FERRY_MODE,
  LIGHT_RAIL_MODE,
  MAIN_TRANSIT_MODE,
  MICROMOBILITY_MODE,
  MICROMOBILITY_RENT_MODE,
  PARK_AND_RIDE_MODE,
  STREETCAR_MODE,
  SUBWAY_MODE,
  WALK_MODE,
  RAIL_MODE,
} from '#/shared/constants';

export const modeIconLookup = {
  [AERIAL_TRAM_MODE]: AerialTram,
  [BICYCLE_MODE]: Bike,
  [BICYCLE_RENT_MODE]: Bike,
  [BUS_FX_MODE]: Bus,
  [BUS_MODE]: Bus,
  [CAR_HAIL_MODE]: Car,
  [CAR_MODE]: Car,
  [CAR_RENT_MODE]: Car,
  [FERRY_MODE]: Ferry,
  [LIGHT_RAIL_MODE]: Max,
  [MAIN_TRANSIT_MODE]: TriMet,
  [MICROMOBILITY_MODE]: Escooter,
  [MICROMOBILITY_RENT_MODE]: Escooter,
  [PARK_AND_RIDE_MODE]: Car,
  [RAIL_MODE]: Wes,
  [STREETCAR_MODE]: Streetcar,
  [SUBWAY_MODE]: Max,
  [WALK_MODE]: Walk,
};

function ModeIcon({ mode, ...svgProps }) {
  const Icon = modeIconLookup[mode && mode.toUpperCase()];

  // prop spreading allows all SVG props to be forwarded to the icon component
  // eslint-disable-next-line react/jsx-props-no-spreading
  return Icon ? <Icon {...svgProps} /> : null;
}

ModeIcon.propTypes = {
  /** Trip mode as defined in the otp engine and otp-ui */
  mode: PropTypes.string.isRequired,
};

export default ModeIcon;
